"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFalconyAnnoucementDescription = exports.getFalconyAnnouncementsPageUrl = exports.getFalconyAnnouncements = void 0;
var axios_1 = __importDefault(require("axios"));
var delay_1 = require("../delay");
var FALCONY_ANNOUNCEMENTS_LAMBDA_URL = "".concat(process.env.REACT_APP_API_BASE_URL, "/contents/falcony-announcements");
var STOP_TIMES_STORAGE_LIMIT = 30 * 60 * 1000; // Milliseconds
var API_RETRY_COUNT = 2;
var API_RETRY_DELAY_MS = 5000;
var getFalconyAnnouncementsDataByUrlFromLocalStorage = function (requestUrl) {
    var localStorageData = localStorage.getItem("falconyAnnouncementsResponses_".concat(requestUrl));
    if (localStorageData) {
        var _a = JSON.parse(localStorageData), falconyAnnouncements = _a.falconyAnnouncements, timestamp = _a.timestamp;
        var now = Date.now();
        if (now - timestamp < STOP_TIMES_STORAGE_LIMIT) {
            return falconyAnnouncements;
        }
    }
};
var saveFalconyAnnouncementsDataByUrlToLocalStorage = function (requestUrl, falconyAnnouncements) {
    var storedData = {
        falconyAnnouncements: falconyAnnouncements,
        timestamp: Date.now()
    };
    localStorage.setItem("falconyAnnouncementsResponses_".concat(requestUrl), JSON.stringify(storedData));
};
var getFalconyAnnouncementsFromApi = function (requestUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var params, falconyAnnouncements;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = { requestUrl: requestUrl };
                return [4 /*yield*/, axios_1.default.get(FALCONY_ANNOUNCEMENTS_LAMBDA_URL, {
                        params: params
                    })];
            case 1:
                falconyAnnouncements = (_a.sent()).data;
                saveFalconyAnnouncementsDataByUrlToLocalStorage(requestUrl, falconyAnnouncements);
                return [2 /*return*/, falconyAnnouncements];
        }
    });
}); };
/**
 * Try fetching Falcony announcements API_RETRY_COUNT amount until success.
 */
var getFalconyAnnouncementsFromApiWithRetry = function (requestUrl, numberOfRetries) {
    if (numberOfRetries === void 0) { numberOfRetries = API_RETRY_COUNT; }
    return __awaiter(void 0, void 0, void 0, function () {
        var falconyAnnouncements, error_1, retriesLeft;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 6]);
                    return [4 /*yield*/, getFalconyAnnouncementsFromApi(requestUrl)];
                case 1:
                    falconyAnnouncements = _a.sent();
                    return [2 /*return*/, falconyAnnouncements];
                case 2:
                    error_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error('Failed to fetch Falcony announcements from API.', error_1);
                    if (!(numberOfRetries > 1)) return [3 /*break*/, 4];
                    retriesLeft = numberOfRetries - 1;
                    // eslint-disable-next-line no-console
                    console.log("Try fetching Falcony announcements again in ".concat(API_RETRY_DELAY_MS, " ms. Retries left: ").concat(retriesLeft));
                    return [4 /*yield*/, (0, delay_1.delay)(API_RETRY_DELAY_MS)];
                case 3:
                    _a.sent();
                    return [2 /*return*/, getFalconyAnnouncementsFromApiWithRetry(requestUrl, retriesLeft)];
                case 4: return [2 /*return*/, []];
                case 5: return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
};
var getFalconyAnnouncements = function (requestUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var source, requestUrlJson, storedFalconyWidgetResponses, falconyAnnouncements;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                source = requestUrl.endsWith('/') ? requestUrl.slice(0, -1) : requestUrl;
                requestUrlJson = /\/json$/i.test(source) ? source : "".concat(source, "/json");
                storedFalconyWidgetResponses = getFalconyAnnouncementsDataByUrlFromLocalStorage(requestUrlJson);
                if (!(storedFalconyWidgetResponses && storedFalconyWidgetResponses.length > 0)) return [3 /*break*/, 1];
                return [2 /*return*/, storedFalconyWidgetResponses];
            case 1: return [4 /*yield*/, getFalconyAnnouncementsFromApiWithRetry(requestUrlJson)];
            case 2:
                falconyAnnouncements = _a.sent();
                return [2 /*return*/, falconyAnnouncements];
        }
    });
}); };
exports.getFalconyAnnouncements = getFalconyAnnouncements;
/**
 * Get url for to announcements page from Falcony API url.
 * API url is in format such as 'https://valimo.pelsu.fi/valimo-vuokralaiset/tiedotteet/json'
 * Announcements page url in in format such as 'https://valimo.pelsu.fi/valimo-vuokralaiset/tiedotteet/'
 */
var getFalconyAnnouncementsPageUrl = function (falconyApiUrl) {
    return falconyApiUrl.replace(/\/json$/, '');
};
exports.getFalconyAnnouncementsPageUrl = getFalconyAnnouncementsPageUrl;
/**
 * Remove line breaks and unnecessary spaces from description
 */
var parseFalconyAnnoucementDescription = function (description) {
    return description.replace(/\s+/g, ' ').trim();
};
exports.parseFalconyAnnoucementDescription = parseFalconyAnnoucementDescription;
//# sourceMappingURL=falconyAnnouncements.js.map